export function showLockIconIfStatementsAreRotatable(statement, context) {
    if (areStatementsRotatable(context)) {
        $(statement).find('.blockStatementSwitch').removeClass('hide');
    }

    return statement;
}

function areStatementsRotatable(context) {
    return $(context).find('[data-rotate-statements-switch]').is(':checked');
}
